module.exports = __webpack_public_path__ + "img/Character_Arataki_Itto_Thumb.3635f07d.png";